module.exports = __webpack_public_path__ + "static/img/money_dark.3ce7a666.png";